import { LocalisationService } from './localisation-service';
import { TranslationService } from './translation-service';

import type { Culture } from '@web-platform/shared-travel-tools-types/src/culture';
import type { I18nService as I18nServiceShape } from '@web-platform/shared-travel-tools-types/src/i18n-service';
import type { Translations } from '@web-platform/shared-travel-tools-types/src/translations';

type Options = { cldr: unknown; culture: Culture; translations: Translations };
type Logger = { error: (msg: string) => void; warn: (msg: string) => void };

export const I18nService = (options: Options, logger: Logger): I18nServiceShape => {
  const translationService = TranslationService({ translations: options.translations, logger });
  const localisationService = LocalisationService(options.cldr, options.culture, logger);
  return {
    ...translationService,
    ...localisationService,
  };
};
